import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const BidderRegistrationDialogTourConfig: AgTechTourConfig = {
    id: 'bidder-registration-dialog-tour',
    name: 'Register Bidder Tour',
    steps: [
        {
            targetId: 'bidder-reg-contact',
            title: 'Contact',
            description: 'Select the contact to register as a bidder. If the contact doesn\'t exist yet, you can create one directly from this dropdown.',
            position: 'bottom',
        },
        {
            targetId: 'bidder-reg-number',
            title: 'Bidder Number',
            description: 'The bidder\'s assigned number for this sale. It auto-populates with the next available number but can be changed if needed.',
            position: 'bottom',
        },
    ]
}
